export const NoRoute = () => {
    return(
        <div>
            <h1>No such route</h1>
        </div>
    )
}